import { render, staticRenderFns } from "./batches.vue?vue&type=template&id=6508ac6f&scoped=true&"
import script from "./batches.vue?vue&type=script&lang=js&"
export * from "./batches.vue?vue&type=script&lang=js&"
import style0 from "./batches.vue?vue&type=style&index=0&id=6508ac6f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508ac6f",
  null
  
)

export default component.exports